import { cn } from "@/lib/utils";

interface CallScoringIconProps {
  className?: string;
  selected?: boolean;
}

export function CallScoringIcon({
  className,
  selected = false,
}: CallScoringIconProps) {
  const strokeColor = selected ? "#84B7EF" : "#DFDFDF";
  const fillColor1 = selected ? "#84B7EF" : "#DFDFDF";
  const fillColor2 = selected ? "#1478E3" : "#BFBFBF";

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
    >
      <g clipPath="url(#clip0_call_scoring)">
        <circle
          cx="11.1416"
          cy="2.9077"
          r="2.2577"
          stroke={strokeColor}
          strokeWidth="1.3"
        />
        <path
          d="M9.2098 5.06348C9.72345 5.52048 10.4001 5.79832 11.1417 5.79833C11.8832 5.79832 12.5598 5.52051 13.0734 5.06358L13.7082 8.78141C13.7315 8.86088 13.7318 8.94543 13.7082 9.02482C13.6846 9.10436 13.6378 9.17551 13.5748 9.22946C13.5118 9.28328 13.4349 9.31817 13.3528 9.32927C13.2706 9.34032 13.1865 9.32701 13.1114 9.29162L11.5219 8.55944C11.4042 8.50158 11.2708 8.47215 11.1396 8.47194C11.0086 8.47222 10.879 8.50165 10.7614 8.55944L9.17185 9.29162C9.09679 9.327 9.01273 9.34032 8.93049 9.32927C8.84842 9.31817 8.77146 9.28328 8.70851 9.22946C8.64548 9.17551 8.5988 9.10435 8.57517 9.02482C8.55164 8.94543 8.5519 8.86088 8.57517 8.78141L9.2098 5.06348Z"
          fill={fillColor1}
        />
        <path
          d="M7.888 12.379C8.02568 12.4422 8.1808 12.4567 8.32779 12.42C8.47479 12.3832 8.60489 12.2975 8.69667 12.177L8.93333 11.867C9.05753 11.7014 9.21857 11.567 9.40372 11.4744C9.58886 11.3819 9.79301 11.3337 10 11.3337H12C12.3536 11.3337 12.6928 11.4741 12.9428 11.7242C13.1929 11.9742 13.3333 12.3134 13.3333 12.667V14.667C13.3333 15.0206 13.1929 15.3598 12.9428 15.6098C12.6928 15.8598 12.3536 16.0003 12 16.0003C8.8174 16.0003 5.76515 14.736 3.51472 12.4856C1.26428 10.2352 0 7.18292 0 4.00033C0 3.6467 0.140476 3.30756 0.390524 3.05752C0.640573 2.80747 0.979711 2.66699 1.33333 2.66699H3.33333C3.68696 2.66699 4.02609 2.80747 4.27614 3.05752C4.52619 3.30756 4.66667 3.6467 4.66667 4.00033V6.00033C4.66667 6.20732 4.61847 6.41147 4.5259 6.59661C4.43333 6.78175 4.29893 6.9428 4.13333 7.06699L3.82133 7.30099C3.69894 7.39444 3.61268 7.52738 3.57719 7.67723C3.54171 7.82707 3.55919 7.98458 3.62667 8.12299C4.53779 9.97357 6.03628 11.4702 7.888 12.379Z"
          fill={fillColor2}
        />
      </g>
      <defs>
        <clipPath id="clip0_call_scoring">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
